import { render, staticRenderFns } from "./forward-btn.vue?vue&type=template&id=9297e2d2&"
import script from "./forward-btn.vue?vue&type=script&lang=js&"
export * from "./forward-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports